import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { type FC, useId } from "react";
import { type Condition } from "../../types";

export const MonthDaySelectField: FC<{
  condition: Condition;
  handleFieldChange: (value: string[]) => void;
  disabled?: boolean;
  hidden?: boolean;
}> = ({ condition, handleFieldChange, disabled, hidden }) => {
  const monthLabelId = useId();
  const dayLabelId = useId();

  return (
    <Box
      hidden={hidden}
      sx={{
        display: "grid",
        gridTemplateColumns: "minmax(0, 1fr) 88px",
        gap: 1,
        width: "100%",
      }}
    >
      <FormControl size="small">
        <InputLabel id={monthLabelId}>Month</InputLabel>
        <Select
          labelId={monthLabelId}
          disabled={disabled}
          variant="outlined"
          size="small"
          label="Month"
          value={monthsIn(condition.values[0])}
          onChange={(event) => {
            const r = monthDayToRegExpExecArray(condition.values[0]);
            const value = toMonthDay(event.target.value, r && r[2] ? r[2] : 1);
            handleFieldChange([value]);
          }}
        >
          {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
            <MenuItem value={month} key={month}>
              {months[month - 1]!}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl size="small">
        <InputLabel id={dayLabelId}>Day</InputLabel>
        <Select
          labelId={dayLabelId}
          disabled={disabled}
          variant="outlined"
          size="small"
          label="Day"
          value={daysIn(condition.values[0])}
          onChange={(event) => {
            const r = monthDayToRegExpExecArray(condition.values[0]);
            const value = toMonthDay(r && r[1] ? r[1] : 1, event.target.value);
            handleFieldChange([value]);
          }}
        >
          {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
            <MenuItem value={day} key={day}>
              {day}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

function monthDayToRegExpExecArray(monthDay?: string): RegExpExecArray | null {
  if (!monthDay) return null;

  return new RegExp(/\((\d+),(\d+)\)/g).exec(monthDay);
}

function daysIn(monthDay?: string): number {
  if (!monthDay) return 1;

  const r = monthDayToRegExpExecArray(monthDay);
  return r && r[2] ? parseInt(r[2]) : 1;
}

function monthsIn(monthDay?: string): number {
  if (!monthDay) return 1;

  const r = monthDayToRegExpExecArray(monthDay);
  return r && r[1] ? parseInt(r[1]) : 1;
}

function toMonthDay(months: string | number, days: string | number): string {
  return `(${months},${days})`;
}

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
